
import { useDisconnect } from 'wagmi';

export const useWalletUtils = () => {
  const { disconnect } = useDisconnect();

  // Handler for disconnecting wallet
  const handleDisconnectWallet = () => {
    // Properly disconnect using wagmi's useDisconnect hook
    disconnect();
    
    // Clear localStorage items
    localStorage.removeItem('wagmi.connected');
    localStorage.removeItem('walletconnect');
    
    // Find and clear any other wallet-related storage
    const walletKeys = Object.keys(localStorage).filter(key => 
      key.includes('wallet') || 
      key.includes('wagmi') || 
      key.includes('w3m')
    );
    
    walletKeys.forEach(key => {
      localStorage.removeItem(key);
    });
    
    // Force reload the page to reset all React state and connections
    window.location.reload();
  };

  return { handleDisconnectWallet };
};
